import { H3, Link, PropTypes as CommonPropTypes, StatelessCol } from '@atlassian/amkt-common';
import classNames from 'classnames';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import CategoryTileRecord from '../../../records/CategoryTile';

import styles from './CategoryTile.less';

const largeScreenClasses = Immutable.Set(['sm', 'md', 'lg', 'xl']);

export default class CategoryTile extends PureComponent {
  static propTypes = {
    categoryTile: PropTypes.instanceOf(CategoryTileRecord),
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    screenClass: CommonPropTypes.screenClass.isRequired,
  };

  render() {
    const isLarge = largeScreenClasses.includes(this.props.screenClass);
    return (
      <StatelessCol
        className={classNames({
          [styles.categoryTile]: true,
          [styles.large]: isLarge,
          [styles.small]: !isLarge,
        })}
        gutterWidth={26}
        screenClass={this.props.screenClass}
        xs={12}
        sm={6}
        md={4}
        lg={4}
        xl={4}
      >
        <div className={styles.categoryTileInner}>
          <Link
            className={styles.categoryTileLink}
            href={this.props.href}
            onClick={this.onClick}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
          >
            <div
              className={styles.categoryImageContainer}
              style={{
                background: this.props.categoryTile.backgroundColor,
              }}
            >
              <div className={styles.categoryImageInner}>
                <div className={styles.categoryImageWrapper}>
                  <img
                    className={styles.categoryImage}
                    src={this.props.categoryTile.image}
                    alt={`${this.props.categoryTile.name} category`}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className={styles.textSection}>
              <div className={styles.textSectionInner}>
                <H3 className={styles.categoryName}>{this.props.categoryTile.name}</H3>
              </div>
            </div>
          </Link>
        </div>
      </StatelessCol>
    );
  }

  onClick = event => {
    this.props.onClick(event, {
      category: this.props.categoryTile.key,
      href: this.props.href,
    });
  };
}
